export default "__VITE_ASSET__DYUakyCq__"